export default __webpack_public_path__ + "static/media/failed_cancelled_icon.f353e7b0.svg";